import { sagas as AlertsSagas } from "./Alerts";
import { sagas as ConfirmSagas } from "./Confirm";
import { sagas as MyzTokenUserSagas } from "./MyzTokenUser";
import { sagas as SubscriptionEmailSagas } from "./SubscriptionEmail";
import { sagas as WotdFormDataSagas } from "./WotdFormData";
import { sagas as WotdPresetSagas } from "./WotdPreset";

const Sagas = [
  MyzTokenUserSagas,
  SubscriptionEmailSagas,
  WotdPresetSagas,
  WotdFormDataSagas,
  ConfirmSagas,
  AlertsSagas,
];
export default Sagas;
